import React from 'react';
import { Flex, Image, Link } from 'components';
import SVGAppStore from './assets/btn-appstore.svg';
import SVGPlayStore from './assets/btn-playstore.svg';

const Badges = props => {
  return (
    <Flex flexDirection={['row']} alignItems={'flex-start'} {...props}>
      <Link to="https://app.appsflyer.com/com.yepstr.android?pid=Hemsida">
        <Image
          width={['150px', '200px']}
          mr={[3]}
          mb={[2, 0]}
          src={SVGPlayStore}
        />
      </Link>
      <Link to="https://app.appsflyer.com/id1069311381?pid=Hemsida">
        <Image width={['135px', '180px']} src={SVGAppStore} />
      </Link>
    </Flex>
  );
};

export default Badges;
